import React, { useState } from "react";
import { Button, Card, Col, Collapse, Row, Space, Tooltip, Typography, } from "antd";
import { useResponsive } from "../../utils/use-responsive";
import { PlusOutlined, QuestionCircleFilled, UpOutlined } from "@ant-design/icons";
import styles from "./approved-card.module.scss";

const { Panel } = Collapse;
const { Title, Text } = Typography;

export const ApprovedCard: React.FC<{
  title: string;
  tooltip: string;
  icon: string;
  details: string;
  extras?: Object;
  optional?: boolean;
  button?: string;
}> = ( {
         title,
         tooltip,
         icon,
         details,
         extras = false,
         optional = false,
         button,
       } ) => {
  const { isXs } = useResponsive();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  function showOptionalOrIcon() {
    if (!isXs && !optional) {
      return (
        <div className={styles["cardIcon"]}>
          <img alt="Icon" src={icon}/>
        </div>
      );
    } else if (!isXs && optional) {
      return (
        <Row justify="space-between">
          <img alt="Icon" src={icon}/>
          <Text type="secondary">Optional</Text>
        </Row>
      );
    }
  }

  return (
    <Col xs={24} sm={12} md={12} lg={8} xl={6}>
      <Card style={{ borderRadius: "8px" }}>
        <Space direction={"vertical"} size={"middle"} className={"full-width"}>
          {showOptionalOrIcon()}

          <Space.Compact direction={"vertical"} className={"full-width"}>
            <Space
              direction={"horizontal"}
              size={"small"}
              className={"ant-row-space-between"}
            >
              <Space direction={"horizontal"} size={"small"}>
                <Text type="secondary" style={{ margin: 0 }}>
                  {title}
                </Text>
                <Tooltip placement="top" title={tooltip}>
                  <QuestionCircleFilled style={{ fontSize: "18px" }}/>
                </Tooltip>
              </Space>
              {isXs && !optional && <img alt="Icon" src={icon}/>}
              {isXs && optional && <Text type="secondary">Optional</Text>}
            </Space>
            {Object.keys(extras).length === 0 && (
              <Title level={2} style={{ margin: 0, fontWeight: "lighter" }}>
                {details}
              </Title>
            )}
            {Object.keys(extras).length != 0 && (
              <Collapse
                className={styles["collapsedCard"]}
                defaultActiveKey={["0"]}
                expandIconPosition="end"
                expandIcon={( { isActive } ) => (
                  <UpOutlined rotate={isActive ? 0 : 180}/>
                )}
              >
                <Panel
                  header={details}
                  key="1"
                  className={styles["collapsedCardHeader"]}
                >
                  <ul>
                    {Object.entries(extras).map(( [key, value], i ) => (
                      <li>
                        {" "}
                        <span>{key}</span>{" "}
                        <span className={styles["extras"]}>{value}</span>
                      </li>
                    ))}
                  </ul>
                </Panel>
              </Collapse>
            )}
          </Space.Compact>
          {button && (
            <Button
              block
              type="default"
              size="large"
              style={{ backgroundColor: "#F2F3F4", borderRadius: "6px" }}
            >
              {button} {<PlusOutlined/>}
            </Button>
          )}
        </Space>
      </Card>
    </Col>
  );
};
